export default {"src":"/_next/static/media/Wim-Van-Cappellen2.ac2889d8.JPG","height":996,"width":1560};